import { Platform } from 'react-native';
import Head from 'expo-router/head';

/**
 * Wrapper around expo-router/head that only renders on web.
 *
 * On native dev builds, the HeadNative implementation calls useIsFocused()
 * which can throw "Couldn't find a navigation context" during re-renders.
 * Screen titles on native are already set via Tabs.Screen / Stack.Screen
 * options in the layout, so Head is only needed on web for <title> tags.
 */
export function WebHead({ children }: { children: React.ReactNode }) {
  if (Platform.OS !== 'web') return null;
  return <Head>{children}</Head>;
}
